var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChampagneGlass(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M199.986 464H159.994V347.75C220.733 332.5 263.225 275.75 254.976 212.25L227.981 27.375C225.732 11.75 212.234 0 196.237 0H59.763C43.766 0 30.268 11.75 28.019 27.375L1.024 212.25C-7.225 275.75 35.267 332.5 96.006 347.75V464H56.014C33.893 464 16.021 481.875 16.021 504C16.021 508.375 19.645 512 24.02 512H231.981C236.355 512 239.979 508.375 239.979 504C239.979 481.875 222.107 464 199.986 464ZM61.762 128L73.51 48H182.49L194.238 128H61.762Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChampagneGlass);
export default __webpack_public_path__ + "static/media/champagne-glass.e92ea7efc790e902ed54a1880e3c930c.svg";
export { ForwardRef as ReactComponent };